export const environment = {
	production: true,
	isHXADevice: false,
	baseUrl: "https://msa.stg02-dev.int.nettask.de/hxa",
	enableKioskOnResume: false,
};
